import { Avatar } from '@assembly-js/design-system';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BlackHeadings, GraySmall } from 'src/theme/colors';
import { getInitials } from 'src/utils/UserUtils';

import { BaseResultItem } from './BaseResultItem';
import { CommandBarEntityAction, RenderParams } from './commandBarTypes';

interface UserResultItemProps extends RenderParams {
  item: RenderParams['item'] & CommandBarEntityAction;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    userNameText: {
      color: BlackHeadings,
    },
    userDetailsWrapper: {
      marginLeft: theme.spacing(2),
    },
    companyText: {
      color: GraySmall,
    },
  }),
);
/**
 * This component renders the user action result item
 */
export const UserResultItem: React.FC<UserResultItemProps> = ({
  item,
  active,
}) => {
  const classes = useStyles();
  const { companyName, fallbackColor, pictureUrl, entityType } =
    item.additionalData;
  const avatarVariant = entityType === 'company' ? 'rounded' : 'circle';
  return (
    <BaseResultItem active={active}>
      <Avatar
        data-testid="user-avatar"
        src={pictureUrl ?? ''}
        text={getInitials(item.name, {
          twoLetters: true,
        })}
        fallbackColor={fallbackColor}
        variant={avatarVariant}
        size="sm"
        className="h-[35px] w-[35px]"
      />
      <div className={classes.userDetailsWrapper}>
        <BaseTypography
          data-testid="user-name"
          className={classes.userNameText}
          fontType="13Medium"
        >
          {item.name}
        </BaseTypography>
        {companyName && (
          <BaseTypography
            data-testid="company-name"
            className={classes.companyText}
            fontType="12Regular"
          >
            {companyName}
          </BaseTypography>
        )}
      </div>
    </BaseResultItem>
  );
};
